import http from "./httpService";
import { getConfig } from "../config/config.js";

const config = getConfig();
const serviceEndpoint = config.apiEndpoint + "/pedidos";

export async function getPedido(recordId) {
  try {
    const response = await http.get(serviceEndpoint + "/" + recordId);
    return response.data.record;
  } catch (error) {
    if (error.message.toUpperCase().includes("NETWORK ERROR")) return error.message.toUpperCase();
    else return [];
  }
}

export async function getPedidos() {
  try {
    const response = await http.get(serviceEndpoint);
    return response.data.records;
  } catch (error) {
    if (error.message.toUpperCase().includes("NETWORK ERROR")) return error.message.toUpperCase();
    else return [];
  }
}

export async function savePedido(data, parentId) {
  if (data._id) return await http.put(serviceEndpoint + "/" + data._id, data);
  else {
    data.parentId = parentId;
    const response = await http.post(serviceEndpoint, data);
    return response.data.record._id;
  }
}

export async function deletePedido(recordId) {
  return await http.delete(serviceEndpoint + "/" + recordId);
}

export async function notifyDelivery(data) {
  return await http.post(serviceEndpoint + "/notify", data);
}
